import React from 'react';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, { headerItemsLabels } from '../../../Common/Header/header';
import {PL_DialogWrapper}  from 'infrastructure/js/components/Dialog/dialog';
import {MatSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import GroupTypesViewGrid from './GroupTypesViewGrid/groupTypesViewGrid';
import CreateGroupTypeDialog from './CreateGroupTypeDialog/createGroupTypeDialog';
import {gridsNames} from '../../../../enums/gridsNames';
import {ImportAcceptFileTypes, ImportTypes} from '../../../../enums/importTypes';

export default class GroupTypesView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.grouptypes.view.');
  }

  componentDidMount() {
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_GROUP_TYPES);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    return {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id:'create',
          label: headerItemsLabels.CREATE,
          icon: 'pl pl-icon-add',
          action: actions.header.onCreateGroupTypeClick,
        },
        {
          id:'edit',
          label: headerItemsLabels.EDIT,
          icon: 'pl pl-edit-icon',
           disabled: !(hasRows && selectedRowsData.size === 1),
          action: actions.header.onEditGroupTypeClick,
          actionData: selectedRowsData.get(0)

        },
      ],

      kebab: {
        menuItems: [
          {
            id: 'importGroupTypes',
            label: headerItemsLabels.IMPORT_GROUP_TYPES,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_GROUP_TYPES],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          {
            id: 'exportGroupTypes',
            label: headerItemsLabels.EXPORT_GROUP_TYPES,
            action: actions.header.exportItems,
            disabled: !hasRows,
            actionData: { gridName: gridsNames.ADMINISTRATION_MAT_SETTINGS_GROUP_TYPES }
          },
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemoveGroupTypesClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData:  selectedRowsData,
          },

        ]
      }
    };
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };



  render() {
    let title = this.labels.get('title');
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <div className="title">{title}</div>

        <Header {...headerItems}/>

        <GroupTypesViewGrid actions={{...this.props.actions.groupTypesViewGridActions, ...this.props.actions.fetchEntitiesActions}} />

        <PL_DialogWrapper dialogComponent={CreateGroupTypeDialog}
                          show={this.props.sCreateGroupTypeDialogData.get('show')}
                          actions={this.props.actions.createGroupTypeDialogActions}
                          sData={this.props.sCreateGroupTypeDialogData}
                          reloadParentComponent={this.reloadPage}
        />
      </div>
    );
  }
}



